export default __webpack_public_path__ + "3156429843db8e05e6e10a4cfb8e4c80.png";